import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Input, InputFloatingLabel, useInputFloatingLabel, useInputChange, useInputClearable } from '.';
import { wrap } from '@atlasgroup/react-wrap';
import { Icon } from '../Icon';
import { WrapperHorizontal, WrapperVertical } from '../../gatsby-theme-docz/components/Wrapper';
export const Inputs = {
  Default: wrap(Input, useInputChange),
  Clearable: wrap(Input, useInputClearable),
  ClearableFlaotingLabel: wrap(InputFloatingLabel, useInputClearable)
};
export const _frontmatter = {};
const layoutProps = {
  Inputs,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "input"
    }}>{`Input`}</h1>
    <p>{`Alternative to basic HTML input`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Input />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <Input mdxType="Input" />
    </Playground>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={1} __code={'<WrapperHorizontal>\n  <Input size=\"small\" />\n  <Input size=\"medium\" />\n  <Input size=\"large\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Input size="small" mdxType="Input" />
        <Input size="medium" mdxType="Input" />
        <Input size="large" mdxType="Input" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "full-width"
    }}>{`Full width`}</h2>
    <Playground __position={2} __code={'<Input isFullWidth />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <Input isFullWidth mdxType="Input" />
    </Playground>
    <h2 {...{
      "id": "other-props"
    }}>{`Other props`}</h2>
    <h3 {...{
      "id": "isround"
    }}>{`isRound`}</h3>
    <Playground __position={3} __code={'<Input isRound />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <Input isRound mdxType="Input" />
    </Playground>
    <h3 {...{
      "id": "prefix--sufix"
    }}>{`Prefix & sufix`}</h3>
    <Playground __position={4} __code={'<WrapperHorizontal>\n  <Input prefix={<Icon name={\'close\'} />} />\n  <Input suffix={<Icon name={\'close\'} />} />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Input prefix={<Icon name={'close'} mdxType="Icon" />} mdxType="Input" />
        <Input suffix={<Icon name={'close'} mdxType="Icon" />} mdxType="Input" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "other-views"
    }}>{`Other views`}</h2>
    <h3 {...{
      "id": "floating-label"
    }}>{`Floating label`}</h3>
    <Playground __position={5} __code={'<WrapperHorizontal>\n  <InputFloatingLabel label={\'Input label\'} size=\"small\" />\n  <InputFloatingLabel label={\'Input label\'} size=\"medium\" />\n  <InputFloatingLabel label={\'Input label\'} size=\"large\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <InputFloatingLabel label={'Input label'} size="small" mdxType="InputFloatingLabel" />
        <InputFloatingLabel label={'Input label'} size="medium" mdxType="InputFloatingLabel" />
        <InputFloatingLabel label={'Input label'} size="large" mdxType="InputFloatingLabel" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "hooks-variants"
    }}>{`Hooks variants`}</h2>
    <p>{`It's highly reccomended to use custom hooks instead default ones provided by this lib, for more info see `}<a parentName="p" {...{
        "href": "#known-bugs"
      }}>{`know bugs section`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { Input, useInputChange, useInputClearable } from '@atlasgroup/react-atlantic';
import { wrap } from '@atlasgroup/react-wrap';

export const Inputs = {
    Default: wrap(Input, useInputChange),
    Clearable: wrap(Input, useInputClearable),
};
`}</code></pre>
    <h3 {...{
      "id": "useinputchange"
    }}>{`useInputChange`}</h3>
    <Playground __position={6} __code={'<WrapperHorizontal>\n  <Inputs.Default isDisabled />\n  <Inputs.Default defaultValue=\"Super input\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Inputs.Default isDisabled />
        <Inputs.Default defaultValue="Super input" />
    </WrapperHorizontal>
    </Playground>
    <h3 {...{
      "id": "useinputclearable"
    }}>{`useInputClearable`}</h3>
    <Playground __position={7} __code={'<WrapperHorizontal>\n  <Inputs.Clearable isDisabled />\n  <Inputs.Clearable defaultValue=\"Super input\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Inputs.Clearable isDisabled />
        <Inputs.Clearable defaultValue="Super input" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "known-bugs"
    }}>{`Known bugs`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`useInputClearable`}</inlineCode>{` clears value on input click`}</li>
      <li parentName="ul">{`hooks do not accept nor pass props that are not handled by them`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`useInputFloatingLabel`}</inlineCode>{` wraps `}<inlineCode parentName="li">{`useInputDefault`}</inlineCode>{` nothing else`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`InputFloatingLabel`}</inlineCode>{` label overlflows input value`}</li>
    </ul>
    <Playground __position={8} __code={'<Inputs.Clearable defaultValue=\"Value to be cleared\" />\n<InputFloatingLabel\n  value=\"Value to be cleared\"\n  label={\'text which overflows value\'}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Input,
      InputFloatingLabel,
      useInputFloatingLabel,
      useInputChange,
      useInputClearable,
      wrap,
      Icon,
      WrapperHorizontal,
      WrapperVertical,
      DefaultLayout,
      Inputs,
      _frontmatter
    }} mdxType="Playground">
    <Inputs.Clearable defaultValue="Value to be cleared" />
    <InputFloatingLabel value="Value to be cleared" label={'text which overflows value'} mdxType="InputFloatingLabel" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      